import { ComponentPropsOptions, h } from '@vue/composition-api';
import Handle from '../handle/Handle.vue';
import { NodeProps, ValidConnectionFunc } from '../../types';
import { Position } from '../../types';
import { defineComponent } from '@vue/composition-api';
import { Fragment } from 'vue-frag';
import { PropType } from 'vue';
import { IWorkflowState } from '@/models';
import NodeLabel from './NodeLabel';

const InputNode = defineComponent<Partial<NodeProps<IWorkflowState>>>({
  name: 'InputNode',

  components: {
    Fragment
  },

  props: {
    sourcePosition: {
      type: String,
      default: () => Position.Bottom
    },

    connectable: {
      type: Boolean,
      default: true
    },

    selected: {
      type: Boolean
    },

    isValidSourcePos: {
      type: Function as PropType<ValidConnectionFunc>
    },
    data: {
      type: Object as PropType<IWorkflowState>,
      default: () => ({})
    }
  } as ComponentPropsOptions<Partial<NodeProps<IWorkflowState>>>,

  setup(props, _context) {
    const label = props.data?.name || props.label;

    return () =>
      h(Fragment, [
        h(NodeLabel, { props }),

        h(Handle, {
          attrs: {
            type: 'source',
            position: props.sourcePosition,
            connectable: props.connectable,
            isValidConnection: props.isValidSourcePos
          }
        })
      ]);
  }
});

export default InputNode;
